<!--
  Status badge (§5). Text + colour dot from the single PRICING_STATUS_MAP.
  Text is always present (never colour-only); role="status" for SR announce.
-->
<span
  class="pf-status-badge"
  [ngClass]="colourClass"
  role="status"
  [attr.aria-label]="ariaLabel"
>{{ displayLabel }}</span>
